/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationPaymentPromotionCodeResponseData,
  GetOrganizationPaymentPromotionCodeResponseDataFromJSON,
  GetOrganizationPaymentPromotionCodeResponseDataFromJSONTyped,
  GetOrganizationPaymentPromotionCodeResponseDataToJSON
} from './GetOrganizationPaymentPromotionCodeResponseData'

/**
 *
 * @export
 * @interface UpdateOrganizationPaymentDiscountResponse
 */
export interface UpdateOrganizationPaymentDiscountResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganizationPaymentDiscountResponse
   */
  status: number
  /**
   *
   * @type {GetOrganizationPaymentPromotionCodeResponseData}
   * @memberof UpdateOrganizationPaymentDiscountResponse
   */
  data: GetOrganizationPaymentPromotionCodeResponseData
}

export function UpdateOrganizationPaymentDiscountResponseFromJSON(
  json: any
): UpdateOrganizationPaymentDiscountResponse {
  return UpdateOrganizationPaymentDiscountResponseFromJSONTyped(json, false)
}

export function UpdateOrganizationPaymentDiscountResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationPaymentDiscountResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOrganizationPaymentPromotionCodeResponseDataFromJSON(json['data'])
  }
}

export function UpdateOrganizationPaymentDiscountResponseToJSON(
  value?: UpdateOrganizationPaymentDiscountResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationPaymentPromotionCodeResponseDataToJSON(value.data)
  }
}
